import type { CSSProperties, ReactNode } from 'react'

/*
  Toolbar — barra de filtros/acciones sobre una tabla o sección.
  Envuelve `.toolbar` de index.css (flex + gap + wrap).
*/
interface ToolbarProps {
  children: ReactNode
  className?: string
  style?: CSSProperties
}

export function Toolbar({ children, className = '', style }: ToolbarProps) {
  return <div className={`toolbar ${className}`.trim()} style={style}>{children}</div>
}
